import { useMutation } from '@tanstack/react-query';

import { queryClient } from '../../shared/providers/react-query-provider';

import { connectCalendar } from './api';
import { getCalendarStatusQueryKey } from './queries';
import { ConnectCalendarPayload } from './types';

export const useConnectCalendarMutation = () =>
    useMutation({
        mutationFn: (payload: ConnectCalendarPayload) => connectCalendar(payload),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: getCalendarStatusQueryKey() });
        },
    });
